import {
    v_tool_category,
    v_tool_subcategory,
    v_product,
    quotation,
    common_attributes,
    v_get_products,
    v_get_manufactured_products,
    v_tooltype,
    tool_category,
    tool_subcategory,
    v_uom,
    v_cart
} from "./APIConstant";
import client1 from "./AxiosInstance";

//tool category api's 
export const get_tool_cat_api = (payload) => {
    return client1.get(v_tool_category, { params: payload })
}

// tool sub category api's 
export const get_tool_sub_cat_api = (payload) => {
    return client1.get(v_tool_subcategory, { params: payload })
}

// product api's 
export const get_product_api = (payload) => {
    return client1.get(v_product, { params: payload })
}

export const get_products = (payload) => {
    return client1.get(v_get_products, { params: payload })
}
//quotation api's 
export const get_quotation_api = (payload) => {
    return client1.get(quotation, { params: payload })
}

export const create_quotation_api=(payload)=>{
    return client1.post(quotation,payload)
}

export const update_quotation_api=(payload)=>{
    return client1.put(quotation,payload)
}

export const delete_quotation_api = (payload) => {
    return client1.delete(quotation, { params: payload })
}

//common attributes api's 
export const get_common_attributes_api = (payload) => {
    return client1.get(common_attributes, { params: payload })
}

//manufactured products api's 
export const get_manufactured_products_api = (payload) => {
    return client1.get(v_get_manufactured_products, { params: payload })
}

export const create_manufactured_products_api=(payload)=>{
    return client1.post(v_get_manufactured_products,payload)
}

export const update_manufactured_products_api=(payload)=>{
    return client1.put(v_get_manufactured_products,payload)
}

export const delete_manufactured_products_api = (payload) => {
    return client1.delete(v_get_manufactured_products, { params: payload })
}

// tool type api's 
export const get_tooltype_api = (payload) => {
    return client1.get(v_tooltype, { params: payload })
}

//tool category api's 
export const get_toolcategories_api = (payload) => {
    return client1.get(tool_category, { params: payload })
}

// tool sub category api's 
export const get_toolsubcategories_api = (payload) => {
    return client1.get(tool_subcategory, { params: payload })
}

//uom api's 
export const get_uom_api = (payload) => {
    return client1.get(v_uom, { params: payload })
}

//cart api's 

export const get_cart_api = (payload) => {
    return client1.get(v_cart, { params: payload })
}

export const create_cart_api=(payload)=>{
    return client1.post(v_cart,payload)
}

export const update_cart_api=(payload)=>{
    return client1.put(v_cart,payload)
}

export const delete_cart_api = (payload) => {
    return client1.delete(v_cart, { params: payload })
}


